import React, { useEffect, useState } from 'react'
import { LuGraduationCap } from 'react-icons/lu'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import ApiEndpoints from './commonComponents/ApiEndpoints'

const RaiseQuery = () => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo } = useInstitute()
  
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed ? `${collapsedWidth + gap}px` : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const [queryData, setQueryData] = useState({
    title: '',
    category: '',
    priority: 'Medium',
    description: '',
    attachments: null
  });
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const categories = [
    'Technical Issue',
    'Billing Inquiry',
    'Account Problem',
    'Feature Request',
    'General Question',
    'Other'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQueryData({
      ...queryData,
      [name]: value
    });
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const handleFileChange = (e) => {
    setQueryData({
      ...queryData,
      attachments: e.target.files[0]
    });
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!queryData.title.trim()) {
      newErrors.title = 'Title is required';
    }
    
    if (!queryData.category) {
      newErrors.category = 'Please select a category';
    }
    
    if (!queryData.description.trim()) {
      newErrors.description = 'Description is required';
    } else if (queryData.description.trim().length < 10) {
      newErrors.description = 'Description must be at least 10 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
    
  //   if (validateForm()) {
  //     // In a real application, you would send the data to your backend here
  //     console.log('Query submitted:', queryData);
  //     setIsSubmitted(true);
      
  //     // Reset form after successful submission
  //     setTimeout(() => {
  //       setQueryData({
  //         title: '',
  //         category: '',
  //         priority: 'Medium',
  //         description: '',
  //         attachments: null
  //       });
  //       setIsSubmitted(false);
  //     }, 3000);
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) return;

  try {
    const payload = {
      title: queryData.title,
      category: queryData.category,
      priority: queryData.priority.toLowerCase(),
      description: queryData.description,
    };

    console.log("Sending Query:", payload);

    const response = await ApiEndpoints.submitGuardianQuery(payload);

    console.log("Query Submitted Successfully:", response.data);

    setIsSubmitted(true);

    setQueryData({
      title: '',
      category: '',
      priority: 'Medium',
      description: '',
      attachments: null,
    });

  } catch (error) {
    console.error(
      "Query Submit Error:",
      error.response?.data || error.message
    );
  }
}; 
  return (
    <>
      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '62px' : '12px',
          paddingRight: isCollapsed ? '62px' : '12px',
        }}
      >
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                overflow: 'visible',
                borderBottom: '1px solid #D1D3D4',
                // width: '100%',
              }}
            >
              <div className="d-flex align-items-center gap-3" style={{ flex: 1 }}>
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>

                <div>
                  <h3
                    className="m-0 fw-bold text-start"
                    style={{
                      letterSpacing: '-0.02em',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: 'clamp(18px, 2.5vw, 22px)',
                      color: '#223843',
                      lineHeight: '1.2',
                      fontFamily: 'Inter, system-ui, sans-serif',
                    }}
                  >
                    Raise a Query
                  </h3>
                  <p
                    className="m-0 mt-1 text-start"
                    style={{
                      fontSize: window.innerWidth < 768 ? '11px' : '13px',
                      color: '#6b7280',
                      fontWeight: '400',
                      fontFamily: 'Inter, system-ui, sans-serif',
                    }}
                  >
                    We’re here to help. Share the details and we’ll get back to you.
                  </p>
                </div>
              </div>

              {!isMobile && <ProfileDropdown logout={logout} />}
            </div>
          </div>
        </div>
        
        {/* Main Content */}
        <div
          className="container mt-0"
          style={{
            paddingLeft: window.innerWidth < 768 ? '16px' : '40px',
            paddingRight: window.innerWidth < 768 ? '16px' : '32px',
            paddingTop: '24px',
            paddingBottom: '32px',
            maxWidth: '100%',
          }}
        >
          <div
            className="card"
            style={{
              border: 'none',
              // border: '1px solid #D1D3D4',
              // borderRadius: '16px',
              // boxShadow:
              //   '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              overflow: 'hidden',
            }}
          >
            <div className="card-body p-4 p-md-5" style={{ background: '#ffffff' }}>
              {isSubmitted ? (
                <div
                  className="alert text-center py-4"
                  role="alert"
                  style={{
                    backgroundColor: '#ECFDF5',
                    border: '1px solid #A7F3D0',
                    color: '#065F46',
                    borderRadius: '14px',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  <i className="fas fa-check-circle fa-3x mb-3 text-success"></i>
                  <h3 style={{ color: '#065F46', fontWeight: 800 }}>Thank You!</h3>
                  <p className="mb-0">Your query has been submitted successfully. We'll get back to you soon.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className='text-start'>
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <label htmlFor="title" className="rq-label">Title <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className={`form-control form-control ${errors.title ? 'is-invalid' : ''}`}
                        id="title"
                        name="title"
                        value={queryData.title}
                        onChange={handleChange}
                        placeholder="Brief summary of your query"
                      />
                      {errors.title && <div className="invalid-feedback">{errors.title}</div>}
                    </div>
                    
                    <div className="col-md-6 mb-4">
                      <label htmlFor="category" className="rq-label">Category <span className="text-danger">*</span></label>
                      <select
                        className={`form-select form-select ${errors.category ? 'is-invalid' : ''}`}
                        id="category"
                        name="category"
                        value={queryData.category}
                        onChange={handleChange}
                      >
                        <option value="">Select a category</option>
                        {categories.map((cat, index) => (
                          <option key={index} value={cat}>{cat}</option>
                        ))}
                      </select>
                      {errors.category && <div className="invalid-feedback">{errors.category}</div>}
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <label htmlFor="priority" className="rq-label">Priority</label>
                      <div className="btn-group w-100" role="group" style={{ gap: '10px' }}>
                        {['Low', 'Medium', 'High', 'Critical'].map(level => (
                          <button
                            key={level}
                            type="button"
                            className={`btn ${queryData.priority === level ? 'btn-dark' : 'btn-outline-secondary'}`}
                            onClick={() => setQueryData({...queryData, priority: level})}
                            style={{
                              borderRadius: '10px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              fontWeight: 700,
                            }}
                          >
                            {level}
                          </button>
                        ))}
                      </div>
                    </div>
                    
                    {/* <div className="col-md-6 mb-4">
                      <label htmlFor="attachments" className="form-label fw-semibold">Attachments (Optional)</label>
                      <div className="file-upload-area border rounded p-3 text-center">
                        <input
                          type="file"
                          className="form-control d-none"
                          id="attachments"
                          onChange={handleFileChange}
                        />
                        <label htmlFor="attachments" className="btn btn-outline-secondary mb-2">
                          <i className="fas fa-cloud-upload-alt me-2"></i>Choose File
                        </label>
                        <p className="small text-muted mb-0">
                          {queryData.attachments ? queryData.attachments.name : 'No file chosen'}
                        </p>
                        <div className="form-text">Upload screenshots or documents if applicable</div>
                      </div>
                    </div> */}
                  </div>
                  
                  <div className="mb-0">
                    <label htmlFor="description" className="rq-label">Description <span className="text-danger">*</span></label>
                    <textarea
                      className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                      id="description"
                      name="description"
                      rows="5"
                      value={queryData.description}
                      onChange={handleChange}
                      placeholder="Please provide detailed information about your query..."
                    ></textarea>
                    {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                    <div className="form-text text-end">
                      {queryData.description.length}/500 characters
                    </div>
                  </div>
                  
                  <div className="d-grid mt-5">
                    <button
                      type="submit"
                      className="btn rq-submit-btn"
                    >
                      <i className="fas fa-paper-plane me-2"></i>Submit Query
                    </button>
                  </div>
                </form>
              )}
            </div>
            
            {/* <div
              className="card-footer py-3"
              style={{
                background: '#F9FAFB',
                borderTop: '1px solid #E5E7EB',
              }}
            >
              <small className="text-muted">
                <i className="fas fa-info-circle me-1"></i>
                For urgent issues, please call our support team directly at 1-800-HELP-NOW.
              </small>
            </div> */}
          </div>
        </div>
      </div>

      <style>
        {`
        .file-upload-area {
          transition: all 0.3s;
          background-color: #f8f9fa;
        }
        
        .file-upload-area:hover {
          background-color: #e9ecef;
          border-color: #86b7fe !important;
        }
        
        .rq-label{
          font-size: 12px;
          font-weight: 700;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 8px;
          font-family: Inter, system-ui, sans-serif;
        }
        
        .form-control, .form-select {
          border-radius: 12px;
          padding: 12px 14px;
          font-family: Inter, system-ui, sans-serif;
          border: 1px solid #E5E7EB;
        }

        .form-control:focus, .form-select:focus {
          border-color: #223843;
          box-shadow: 0 0 0 4px rgba(34, 56, 67, 0.12);
        }

        .rq-submit-btn{
          background: #223843;
          border: none;
          border-radius: 12px;
          padding: 12px 16px;
          color: #ffffff;
          font-family: Inter, system-ui, sans-serif;
          font-weight: 800;
          transition: all 0.2s ease;
        }

        .rq-submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
          background: #1f323a;
        }
        
        @media (max-width: 768px) {
          .btn-group .btn {
            padding: 0.5rem;
            font-size: 0.875rem;
          }
        }
        `}
      </style>
    </>
  );
};

export default RaiseQuery;